import React from "react";
import "./RegisterSuccess.css";
import Footer from "../Footer/Footer";
import NavBar from "../NavBar/NavBar";

class RegisterSuccess extends React.Component {
    render() {
        return (
            <div>
                <NavBar/>
                <p className="empty-content">You have successfully registered your organization, your account approval is pending. Check back soon.</p>
                <Footer/>
            </div>
        )
    }
}

export default RegisterSuccess;